































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { dictServe, performanceServer, safetyAndEnvironmentAssessmentServer } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class AddDialog extends Vue {
  private visible = false;
  private userData: any = {};

  // 考核类型
  subSpaceByAuthOptions: any = [];

  // 职务
  spacePostByAuthOptions: any = [
    {
      name: '月度',
    },
    {
      name: '季度',
    },
    {
      name: '年度',
    },
  ];
  // 周期
  cycleOptions: any = [];

  // 月度周期
  cycleYearOptions: any = [
    {
      name: '一月',
    },
    {
      name: '二月',
    },
    {
      name: '三月',
    },
    {
      name: '四月',
    },
    {
      name: '五月',
    },
    {
      name: '六月',
    },
    {
      name: '七月',
    },
    {
      name: '八月',
    },
    {
      name: '九月',
    },
    {
      name: '十月',
    },
    {
      name: '十一月',
    },
    {
      name: '十二月',
    },
  ];

  // 季度周期
  cycleQuarterOptions: any = [
    {
      name: '第一季度（一月至三月）',
    },
    {
      name: '第二季度（四月至六月）',
    },
    {
      name: '第三季度（七月至九月）',
    },
    {
      name: '第四季度（十月至十二月）',
    },
  ];
  formData: any = {
    id: '',
    assessType: '',
    assessCycleUnit: '',
    assessCycleDate: '',
    cycleUnit: '',
    assessCycleDateStart: '',
    assessCycleDateEnd: '',
    adjustFlag: false,
    assessContent: '',
    assessCycleMonth: 0,
    assessCycleSeason: 0,
    assessCycleYear: 0,
    spaceId: '',
    staffId: '',
    staffName: '',
    suggestion: '',
  };

  userRules: any = {
    assessType: [{ required: true, trigger: 'blur', message: '请选择考核类别' }], // 任务名称
    assessCycleUnit: [{ required: true, trigger: 'blur', message: '请选择考核类型' }], // 执行部门
    cycleUnit: [{ required: true, trigger: 'blur', message: '请选择考核周期' }], // 执行部门
  };

  private async showAddDialog(type: any, data?: any) {
    const info: any = localStorage.getItem('userInfo');
    this.userData = JSON.parse(info);
    this.formData = {
      id: '',
      assessType: '',
      assessCycleUnit: '',
      assessCycleDate: '',
      cycleUnit: '',
      assessCycleDateStart: '',
      assessCycleDateEnd: '',
      adjustFlag: false,
      assessContent: '',
      assessCycleMonth: 0,
      assessCycleSeason: 0,
      assessCycleYear: 0,
      spaceId: this.userData.spaceId,
      staffId: '',
      staffName: '',
      suggestion: '',
    };
    this.subSpaceByAuthOptions = [];
    this.getSubSpaceByAuth();
    this.visible = true;
  }

  // 选择考核类型时年度、月度、季度
  changeValue(data: any) {
    this.formData.cycleUnit = '';
    if (data === '月度') {
      this.cycleOptions = this.cycleYearOptions;
    }
    if (data === '季度') {
      this.cycleOptions = this.cycleQuarterOptions;
    }
  }

  // 选择选择考核周期时月度、季度
  changeCycle(data: any) {
    const date: any = this.getTime();
    if (data === '一月') {
      this.formData.assessCycleMonth = 1;
      this.formData.assessCycleSeason = 1;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-01-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-01-31';
    }
    if (data === '二月') {
      this.formData.assessCycleMonth = 2;
      this.formData.assessCycleSeason = 1;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      const year = new Date(date).getFullYear(); // 指定年份
      const isLeap = year % 400 == 0 || (year % 100 != 0 && year % 4 == 0); // 根据年份判断是否为闰年
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-02-01';
      if (isLeap) {
        this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-02-29';
      } else {
        this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-02-28';
      }
    }
    if (data === '三月') {
      this.formData.assessCycleMonth = 3;
      this.formData.assessCycleSeason = 1;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-03-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-03-31';
    }
    if (data === '四月') {
      this.formData.assessCycleMonth = 4;
      this.formData.assessCycleSeason = 2;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-04-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-04-30';
    }
    if (data === '五月') {
      this.formData.assessCycleMonth = 5;
      this.formData.assessCycleSeason = 2;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-05-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-05-31';
    }
    if (data === '六月') {
      this.formData.assessCycleMonth = 6;
      this.formData.assessCycleSeason = 2;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-06-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-06-30';
    }
    if (data === '七月') {
      this.formData.assessCycleMonth = 7;
      this.formData.assessCycleSeason = 3;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-07-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-07-31';
    }
    if (data === '八月') {
      this.formData.assessCycleMonth = 8;
      this.formData.assessCycleSeason = 3;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-08-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-08-31';
    }
    if (data === '九月') {
      this.formData.assessCycleMonth = 9;
      this.formData.assessCycleSeason = 3;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-09-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-09-30';
    }
    if (data === '十月') {
      this.formData.assessCycleMonth = 10;
      this.formData.assessCycleSeason = 4;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-10-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-10-31';
    }
    if (data === '十一月') {
      this.formData.assessCycleMonth = 11;
      this.formData.assessCycleSeason = 4;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-11-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-11-30';
    }
    if (data === '十二月') {
      this.formData.assessCycleMonth = 12;
      this.formData.assessCycleSeason = 4;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-12-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-12-31';
    }
    if (data === '第一季度（一月至三月）') {
      this.formData.assessCycleSeason = 1;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-01-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-03-31';
    }
    if (data === '第二季度（四月至六月）') {
      this.formData.assessCycleSeason = 2;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-04-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-06-30';
    }
    if (data === '第三季度（七月至九月）') {
      this.formData.assessCycleSeason = 3;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-07-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-09-30';
    }
    if (data === '第四季度（十月至十二月）') {
      this.formData.assessCycleSeason = 4;
      this.formData.assessCycleYear = new Date(date).getFullYear();
      this.formData.assessCycleDateStart = new Date(date).getFullYear() + '-10-01';
      this.formData.assessCycleDateEnd = new Date(date).getFullYear() + '-12-31';
    }
  }

  changeYearCycle(data: any) {
    this.formData.assessCycleYear = Number(data);
    this.formData.assessCycleDateStart = data + '-01-01';
    this.formData.assessCycleDateEnd = data + '-12-31';
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.formData = {
      id: '',
      assessType: '',
      assessCycleUnit: '',
      assessCycleDate: '',
      cycleUnit: '',
      assessCycleDateStart: '',
      assessCycleDateEnd: '',
      adjustFlag: false,
      assessContent: '',
      assessCycleMonth: 0,
      assessCycleSeason: 0,
      assessCycleYear: 0,
      spaceId: '',
      staffId: '',
      staffName: '',
      suggestion: '',
    };
    this.userData = {};
    this.visible = false;
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    dictServe
      .getDetailsMapByName('assessType')
      .then((res: any) => {
        // console.log(res.data);
        for (const i in res.data) {
          this.subSpaceByAuthOptions.push({
            value: res.data[i],
            label: res.data[i],
          }); //属性
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      this.addFunctionData();
    });
  }

  /**
   * 【接口】行内新增功能
   */
  private async addFunctionData() {
    this.formData.assessCycleDate = this.getTime();
    safetyAndEnvironmentAssessmentServer
      .addPerformanceData(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功');
          this.returnDialog(); // 返回到父级页面
          this.$emit('refreshData');
        } else {
          // console.log(res);
          this.$message.error(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('添加失败');
      });
  }

  getTime() {
    const date = new Date(); //如果date为13位不需要乘1000
    const SY = date.getFullYear();
    const SM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const SD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    // const Sh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    // const Sm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    // const Ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return SY + '-' + SM + '-' + SD;
  }

  handleChange(value: any) {
    // console.log(value);
  }
}
